// Lightweight cross-panel signal so the chapters panel can refresh its test
// dropdown when the tests panel mutates the test list. They're sibling
// components with independent state on the same page; a window CustomEvent
// decouples them without lifting state into every settings host.
export const TESTS_CHANGED_EVENT = 'tishnotes:tests-changed';

export function notifyTestsChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(TESTS_CHANGED_EVENT));
  }
}
